(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mumuso-mall-voucher-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-mall-voucher-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('mallvoucher') !== '1') return;

    const close = () => dialog.close();

    dialog.querySelectorAll('[data-mall-voucher-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    dialog.showModal();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    function getMumusoRangeElements(range) {
    const minInput = range.querySelector('.mumuso-price-filter__range-input--min');
    const maxInput = range.querySelector('.mumuso-price-filter__range-input--max');
    const minLabel = range.closest('.mumuso-price-filter__body')?.querySelector('.mumuso-price-filter__value--min');
    const maxLabel = range.closest('.mumuso-price-filter__body')?.querySelector('.mumuso-price-filter__value--max');
    return { minInput, maxInput, minLabel, maxLabel };
  }

  function clampMumusoPrice(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function formatMumusoPrice(value) {
    return `${Math.round(value)}€`;
  }

  function updateMumusoPriceRange(range) {
    const { minInput, maxInput, minLabel, maxLabel } = getMumusoRangeElements(range);
    if (!minInput || !maxInput) return;

    const minValue = Number(minInput.value || minInput.min || 0);
    const maxValue = Number(maxInput.value || maxInput.max || 0);
    const rangeMax = Number(range.dataset.rangeMax || maxInput.max || minInput.max || 1);
    const minPercent = rangeMax > 0 ? Math.max(0, Math.min(100, (minValue / rangeMax) * 100)) : 0;
    const maxPercent = rangeMax > 0 ? Math.max(0, Math.min(100, (maxValue / rangeMax) * 100)) : 100;

    range.style.setProperty('--min-percent', `${Math.min(minPercent, maxPercent)}%`);
    range.style.setProperty('--max-percent', `${Math.max(minPercent, maxPercent)}%`);
    if (minLabel) minLabel.textContent = formatMumusoPrice(minValue);
    if (maxLabel) maxLabel.textContent = formatMumusoPrice(maxValue);
  }

  function setMumusoPriceRangeValue(range, handle, value) {
    const { minInput, maxInput } = getMumusoRangeElements(range);
    if (!minInput || !maxInput) return;

    const rangeMax = Number(range.dataset.rangeMax || maxInput.max || minInput.max || 1);
    let minValue = Number(minInput.value || 0);
    let maxValue = Number(maxInput.value || rangeMax);
    const nextValue = clampMumusoPrice(Math.round(value), 0, rangeMax);

    if (handle === 'min') {
      minValue = Math.min(nextValue, maxValue);
    } else {
      maxValue = Math.max(nextValue, minValue);
    }

    minInput.value = String(minValue);
    maxInput.value = String(maxValue);
    minInput.dispatchEvent(new Event('input', { bubbles: true }));
    maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    updateMumusoPriceRange(range);
  }

  function getMumusoPriceFromPointer(range, clientX) {
    const visual = range.querySelector('.mumuso-price-filter__range-visual');
    if (!visual) return 0;

    const rect = visual.getBoundingClientRect();
    const rangeMax = Number(range.dataset.rangeMax || 1);
    const ratio = rect.width > 0 ? clampMumusoPrice((clientX - rect.left) / rect.width, 0, 1) : 0;
    return ratio * rangeMax;
  }

  function bindMumusoPriceRangeDragging(range) {
    const visual = range.querySelector('.mumuso-price-filter__range-visual');
    const minHandle = range.querySelector('.mumuso-price-filter__range-handle--min');
    const maxHandle = range.querySelector('.mumuso-price-filter__range-handle--max');
    if (!visual || !minHandle || !maxHandle) return;

    let activeHandle = null;

    const startDrag = (handle, event) => {
      activeHandle = handle;
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget.setPointerCapture?.(event.pointerId);
      setMumusoPriceRangeValue(range, activeHandle, getMumusoPriceFromPointer(range, event.clientX));
    };

    minHandle.addEventListener('pointerdown', (event) => startDrag('min', event));
    maxHandle.addEventListener('pointerdown', (event) => startDrag('max', event));

    visual.addEventListener('pointerdown', (event) => {
      if (event.target === minHandle || event.target === maxHandle) return;
      const { minInput, maxInput } = getMumusoRangeElements(range);
      const clickedValue = getMumusoPriceFromPointer(range, event.clientX);
      const minDistance = Math.abs(clickedValue - Number(minInput?.value || 0));
      const maxDistance = Math.abs(clickedValue - Number(maxInput?.value || range.dataset.rangeMax || 0));
      startDrag(minDistance <= maxDistance ? 'min' : 'max', event);
    });

    window.addEventListener('pointermove', (event) => {
      if (!activeHandle) return;
      setMumusoPriceRangeValue(range, activeHandle, getMumusoPriceFromPointer(range, event.clientX));
    });

    window.addEventListener('pointerup', () => {
      activeHandle = null;
    });
  }

  function initMumusoPriceRanges() {
    document.querySelectorAll('.mumuso-price-filter__range').forEach((range) => {
      if (range.dataset.mumusoRangeReady === 'true') return;
      range.dataset.mumusoRangeReady = 'true';
      range.querySelectorAll('.mumuso-price-filter__range-input').forEach((input) => {
        input.addEventListener('input', () => updateMumusoPriceRange(range));
        input.addEventListener('change', () => updateMumusoPriceRange(range));
      });
      bindMumusoPriceRangeDragging(range);
      updateMumusoPriceRange(range);
    });
  }

  initMumusoPriceRanges();
  document.addEventListener('shopify:section:load', initMumusoPriceRanges);
  } catch(e) { console.error(e); }
})();

})();
